import { render, staticRenderFns } from "./habitHomeListNutrition.vue?vue&type=template&id=62066b14&scoped=true"
import script from "./habitHomeListNutrition.vue?vue&type=script&lang=js"
export * from "./habitHomeListNutrition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62066b14",
  null
  
)

export default component.exports